<h1 i18n="@@upp.families.modify.title">Modify Hotel Family</h1>

<div class="container-fluid">
  <ama-loading-alert [sendingStatus]="sendingStatus" message="Loading..." i18n-message="@@upp.global.messages.loading">
  </ama-loading-alert>
</div>

<ama-upp-notification
  [mainMessages]="mainMessages"
  [notification]="(notification$ | async)!"
  (closeNotificationEvent)="closeNotification()"
>
</ama-upp-notification>

<ama-ng-upp-families-details
  [familiesDetailsForm]="familyForm"
  [familyDetails]="familyDetail"
  [readonly]="readonly"
  [isFamilyTypeDisabled]="true"
  [parent]="uppComponent"
>
</ama-ng-upp-families-details>

@if (!sendingStatus) {
<div class="d-flex justify-content-end">
  <button
    i18n="@@upp.global.button.cancel"
    type="button"
    class="btn btn-outline-primary mb-2 mb-md-0 me-2"
    (click)="cancelModification()"
  >
    Cancel
  </button>
  <button
    i18n="@@upp.global.button.save"
    type="submit"
    class="btn btn-primary mb-2 mb-md-0 me-2"
    [disabled]="!familyForm.valid"
    [disabled]="!saveButtonEnabled()"
    (click)="saveModification()"
  >
    Save
  </button>
</div>
} @if (sendingStatus) {
<div class="d-flex justify-content-end">
  <button i18n="@@upp.global.button.cancel" type="button" disabled class="btn btn-outline-primary mb-2 mb-md-0 me-2">
    Cancel
  </button>
  <button i18n="@@upp.global.button.save" type="button" disabled class="btn btn-primary mb-2 mb-md-0 me-2">
    Save
  </button>
</div>
}
